import { Button } from './Button';
import styled, { css } from 'styled-components';
import { Icon } from './Icon';
import { useEffect, useState } from 'react';
import { Items } from 'data/items';
import { useDimensions } from 'hooks/useDimensions';
import { isTouch } from 'utils/isTouch';
import { COLORS } from 'constants/colors';

const BodyWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: flex-start;
`;

const NavigateIcon = styled(Icon)`
  cursor: pointer;
  font-size: 35px !important;

  transition: 0.5s;

  ${!isTouch &&
  css`
    &:hover {
      transform: translate(0px, -5px);
    }
  `}
`;

const BigImage = styled.img`
  width: 100%;
  height: auto;
  max-height: 100%;
  object-fit: contain;
  transition: 0.5s;
`;

export const HomeContent = () => {
  const [imageIndex, setImageIndex] = useState(0);
  const [changed, setChanged] = useState(false);

  const [imageLoaded, setImageLoaded] = useState(false);

  const item = Items[imageIndex];

  const { isMediumWidth } = useDimensions();

  useEffect(() => {
    if (changed) {
      setTimeout(() => setChanged(false), 500);
    }
  }, [changed]);

  return (
    <BodyWrapper
      style={{
        display: 'flex',
        flexDirection: isMediumWidth ? 'column' : 'row',
        alignItems: isMediumWidth ? 'center' : 'flex-end',
        justifyContent: 'flex-end',
      }}
    >
      <div
        style={{
          width: isMediumWidth ? '100%' : 'calc(100% - 500px)',
          maxHeight: isMediumWidth ? 'calc(100% - 350px)' : 'none',
          height: '100%',
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'flex-end',
          marginBottom: isMediumWidth ? 50 : 0,
        }}
      >
        <BigImage
          src={item?.imgSrc.default}
          alt={item.title}
          onLoad={() => {
            setImageLoaded(true);
          }}
          style={{ visibility: imageLoaded && !changed ? 'visible' : 'hidden', opacity: changed || !imageLoaded ? 0 : 1 }}
        />
      </div>
      <div style={{ width: isMediumWidth ? '100%' : 400, marginLeft: isMediumWidth ? 0 : 100, position: 'relative', color: COLORS.white }}>
        <div style={{ marginBottom: 30 }}>
          <div
            style={{ marginBottom: 10, fontWeight: 600, fontSize: 20, transition: '0.5s', opacity: changed ? 0 : 1, color: COLORS.white }}
          >
            {item?.title}
          </div>
          <div style={{ fontWeight: 300, fontSize: 15, transition: '0.5s', opacity: changed ? 0 : 1, color: COLORS.white }}>
            {item?.description}
          </div>
        </div>
        <Button
          onClick={(e) => {
            window.open(item?.link, '_blank');
          }}
          style={{ marginBottom: isMediumWidth ? 0 : 60, transition: '0.5s', opacity: changed ? 0 : 1 }}
        >
          Buy item
        </Button>
        <div
          style={{
            display: 'flex',
            position: isMediumWidth ? 'absolute' : 'unset',
            right: 0,
            bottom: 0,
          }}
        >
          <NavigateIcon
            onClick={() => {
              setChanged(true);

              setTimeout(() => {
                setImageLoaded(false);
                if (!changed) {
                  if (imageIndex === 0) {
                    setImageIndex(Items?.length - 1);
                  } else {
                    setImageIndex((i) => i - 1);
                  }
                }
              }, 500);
            }}
            style={{ marginRight: 20 }}
          >
            {'navigate_before'}
          </NavigateIcon>
          <NavigateIcon
            onClick={() => {
              setChanged(true);

              setTimeout(() => {
                setImageLoaded(false);
                if (!changed) {
                  if (imageIndex === Items.length - 1) {
                    setImageIndex(0);
                  } else {
                    setImageIndex((i) => i + 1);
                  }
                }
              }, 500);
            }}
          >
            {'navigate_next'}
          </NavigateIcon>
        </div>
      </div>
    </BodyWrapper>
  );
};
